<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
      [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
      style="margin-right: 10px; cursor: pointer;"
    (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
      <li [class.active]="tab.id === activeTab" [class.disabled]="tab.disabled">
        <a (click)="!tab.disabled && changeTab(tab.id)"
          style="cursor: pointer;"
          class="btn-sm"
          [class.disabled]="tab.disabled"
          [style.pointer-events]="tab.disabled ? 'none' : 'auto'"
          [style.opacity]="tab.disabled ? '0.5' : '1'">
          {{ tab.name }}
        </a>
      </li>
    }
  </ul>

  <div class="tab-content">
    <!-- Form Entry Tab -->
    @if (activeTab === 1) {
      <div class="tab-pane active" style="overflow-y: auto; overflow-x: hidden; max-height: calc(90vh - 200px);">
        <div class="form-horizontal">
          <!-- SMALL loader for form content only -->
          @if (showFormLoader) {
            <div class="row formLoader">
              <i class="fa fa-spinner fa-spin gt-refresh"></i>
            </div>
          }

          @if (!showFormLoader) {
            <div>
              <!-- Entity Information Table -->
              <table class="table table-bordered form-inline enityDetails">
                <tr>
                  @for (item of entityList; track $index) {
                    <td>
                      <span>{{ item.key }}</span>
                    </td>
                  }
                </tr>
                <tr>
                  @for (item of entityList; track $index) {
                    <td>
                      <span>{{ item.value }}</span>
                    </td>
                  }
                </tr>
              </table>

              <table class="I_Entry table table-bordered form-inline">
                <thead>
                  <tr>
                    <th colspan="10">{{modalTitle}}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of scheduleIFormView.rows; track itemTracker(i, row); let i = $index) {
                    <tr class="formDataBlock">
                      <td>{{row.num}}</td>
                      <td class="descBlock">
                        @if (row.num == '1a'|| row.num == '1b' || row.num == '1c' || row.num == '2a' || row.num == '2b') {
                          <span>
                            <input type="checkbox"
                              [checked]="row.value === true"
                              (change)="onGroupCheckboxChange(i, row, $event)"
                              name="{{row.num}}"/>
                            </span>
                          }
                          @if (row.num == 3 || row.num == 4 || row.num == 5 || row.num == 6) {
                            <span class="goldDataLink"

                            (click)="goldNavigation()">{{row.description}}</span>
                          }
                          @if (!(row.num == 3 || row.num == 4 || row.num == 5 || row.num == 6)) {
                            <span>{{row.description}}</span>
                          }
                          @if (row.num == '1c' || row.num == 5 || row.num == 16) {
                            <input type="text"
                              [disabled]="row.conditionalField"
                              [(ngModel)]="row.value_user_input"
                              name="{{row.num}}"

                              class="form-control input-md">
                            }

                            @if (row.num == 4) {
                              <div>
                                <span style="width: 116px; display: inline-block;">Business Name</span>
                                <input type="text"
                                  [disabled]="row.conditionalField"
                                  [(ngModel)]="row.value_user_input"
                                  name="{{row.num}}"
                                  class="form-control input-md">
                                </div>
                              }
                              @if (row.num == 4) {
                                <div style="margin-top: 6px;">
                                  <span style="width: 116px; display: inline-block;">EIN</span>
                                  <input type="text"
                                    [disabled]="row.conditionalField"
                                    [(ngModel)]="row.value_user_input3"
                                    name="{{row.num}}"
                                    class="form-control input-md">
                                  </div>
                                }
                                @if (row.num == 4) {
                                  <div style="margin-top: 6px;">
                                    <span style="width: 116px; display: inline-block;">Name Control</span>
                                    <input type="text"
                                      [disabled]="row.conditionalField"
                                      [(ngModel)]="row.value_user_input4"
                                      name="{{row.num}}"
                                      class="form-control input-md">
                                    </div>
                                  }

                                  @if (row.num == '3a' || row.num == '3b' || row.num == '3c' || row.num == '6a' || row.num == '6b' || row.num == '6c') {
                                    <input type="text"
                                      [disabled]="row.conditionalField"
                                      [(ngModel)]="row.value"
                                      name="{{row.num}}"

                                      class="form-control input-md">
                                    }
                                    @if (row.num == 9 || row.num == 11 || row.num == '7a1' || row.num == '7a2' || row.num == '7b1' || row.num == '7b2' || row.num == '13a' || row.num == '13b' || row.num == '13c') {
                                      <input type="text"
                                        only-digits
                                        format="number"
                                        [disabled]="row.conditionalField"
                                        [(ngModel)]="row.value"
                                        name="{{row.num}}"

                                        class="form-control input-md">
                                      }
                                    </td>
                                    <td align="right">
                                      @if (row.num == 3 || row.num == 4 || row.num == 5 || row.num == 6 || row.num == 8 || row.num == 12 || row.num == 13 || row.num == '14a' || row.num == '14b' || row.num == 15 || row.num == 16 || row.num == 17 || row.num == 18 || row.num == 10 || row.num == 19 || row.num == '20a' || row.num == '20b' || row.num == '20c') {
                                        <div
                                          class="yes-no-wrapper">
                                          <span>Yes </span>
                                          <input type="checkbox"
                                            name="yes_{{row.num}}"
                                            [checked]="row.value === true"
                                            (click)="onYesNoCheckboxClick(i, row, 'yes')"/>
                                            <span style="margin-left: 6px;">No </span>
                                            <input type="checkbox"
                                              name="no_{{row.num}}"
                                              [checked]="row.value === false"
                                              (click)="onYesNoCheckboxClick(i, row, 'no')"/>
                                            </div>
                                          }
                                        </td>
                                      </tr>
                                    }
                                  </tbody>
                                </table>
                              </div>
                            }
                          </div>
                        </div>
                      }

                      <!-- Form View Tab -->
                      @if (activeTab === 2) {
                        <div class="tab-pane active" style="overflow-y: auto; overflow-x: hidden; max-height: calc(90vh - 200px);">
                          @if (showFormLoader) {
                            <div class="row formLoader">
                              <i class="fa fa-spinner fa-spin gt-refresh"></i>
                            </div>
                          }

                          @if (!showFormLoader) {
                            <div class="PC_SCHD_I form-horizontal">
                              <table class="form-inline">
                                <thead>
                                  <tr>
                                    <th colspan="3">
                                      <span class="schd-name">Schedule I</span>
                                      <span class="schd-desc">Other Information</span>
                                      <span class="schd-ins">(see instructions)</span>
                                    </th>
                                  </tr>
                                </thead>
                              </table>

                              <div class="col-md-6">
                                <table class="form-inline">
                                  <thead>
                                    <tr>
                                      <th colspan="1"></th>
                                      <th colspan="1"></th>
                                      <th colspan="1"><span>Yes</span><span>No</span></th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    @for (row of scheduleIFormView1; track $index) {
                                      <tr>
                                        <td class="lineNo">{{row.num}}</td>
                                        <td>
                                          @if (row.num == '1a' || row.num == '1b' || row.num == '1c' || row.num == '2a' || row.num == '2b') {
                                            <input
                                              disabled="true"
                                              type="checkbox"
                                              [checked]="row.value === true" />
                                            }
                                            <span>{{row.description}}</span>
                                            <!--Start of Carrot & Dollar Symbol Code-->
                                            @if (row.num == '1c' || row.num == 4 || row.num == 5 || row.num == '6a' || row.num == '6b' || row.num == '6c') {
                                              <span class="right-arrow"><i class="fa fa-caret-right"></i></span>
                                            }
                                            @if (row.num == '7a1' || row.num == '7a2') {
                                              <span class="dollar-percent"><i class="fa fa-dollar"></i></span>
                                            }
                                            <!--End of Carrot & Dollar Symbol Code-->
                                            @if (row.num == '1c' || row.num == 5) {
                                              <input type="text"
                                                name="{{row.num}}"
                                                [(ngModel)]="row.value_user_input"

                                                class="form-control input-md"
                                                disabled="true">
                                              }

                                              @if (row.num == 4) {
                                                <div>
                                                  <span style="width: 116px; display: inline-block;">Business Name</span>
                                                  <input type="text"
                                                    [(ngModel)]="row.value_user_input"
                                                    name="{{row.num}}"
                                                    class="form-control input-md"
                                                    disabled="true">
                                                  </div>
                                                }
                                                @if (row.num == 4) {
                                                  <div style="margin-top: 6px;">
                                                    <span style="width: 116px; display: inline-block;">EIN</span>
                                                    <input type="text"
                                                      [(ngModel)]="row.value_user_input3"
                                                      name="{{row.num}}"
                                                      class="form-control input-md"
                                                      disabled="true">
                                                    </div>
                                                  }
                                                  @if (row.num == 4) {
                                                    <div style="margin-top: 6px;">
                                                      <span style="width: 116px; display: inline-block;">Name Control</span>
                                                      <input type="text"
                                                        [(ngModel)]="row.value_user_input4"
                                                        name="{{row.num}}"
                                                        class="form-control input-md"
                                                        disabled="true">
                                                      </div>
                                                    }

                                                    @if (row.num == '3a' || row.num == '3b' || row.num == '3c' || row.num == '6a' || row.num == '6b' || row.num == '6c' || row.num == '7a1' || row.num == '7a2') {
                                                      <div [attr.data-ng-class]="{'color-red': row.value < 0 }"
                                                        class="input_disabled"
                                                      >{{row.value}}</div>
                                                    }
                                                  </td>
                                                  <td>
                                                    @if (row.num == 3 || row.num == 4 || row.num == 5 || row.num == 6) {
                                                      <div class="yes-no-div">
                                                        @if (row.value == true) {
                                                          <div>
                                                            <span>
                                                              <input type="checkbox" [checked]="true" name="{{row.num}}" disabled="true">
                                                            </span>
                                                            <span>
                                                              <input type="checkbox" name="{{row.num}}" disabled="true">
                                                            </span>
                                                          </div>
                                                        }
                                                        @if (row.value == false) {
                                                          <div>
                                                            <span>
                                                              <input type="checkbox" name="{{row.num}}" disabled="true">
                                                            </span>
                                                            <span>
                                                              <input type="checkbox" [checked]="true" name="{{row.num}}" disabled="true">
                                                            </span>
                                                          </div>
                                                        }
                                                      </div>
                                                    }
                                                  </td>
                                                </tr>
                                              }
                                            </tbody>
                                          </table>
                                        </div>

                                        <div class="col-md-6">
                                          <table class="form-inline">
                                            <thead>
                                              <tr>
                                                <th colspan="1"></th>
                                                <th colspan="1"></th>
                                                <th colspan="1"><span>Yes</span><span>No</span></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              @for (row of scheduleIFormView2; track $index) {
                                                <tr>
                                                  <td class="lineNo">{{row.num}}</td>
                                                  <td>
                                                    @if (row.num == '1a' || row.num == '1b' || row.num == '1c' || row.num == '2a' || row.num == '2b') {
                                                      <input
                                                        disabled="true"
                                                        type="checkbox"
                                                        [checked]="row.value === true"
                                                        name="{{row.num}}" />
                                                      }
                                                      <span>{{row.description}}</span>
                                                      <!--Start of Carrot & Dollar Symbol Code-->
                                                      @if (row.num == '1c' || row.num == 4 || row.num == 5 || row.num == '6a' || row.num == '6b' || row.num == '6c' || row.num == 10 || row.num == 11 || row.num == '13a' || row.num == '13b' || row.num == '13c' || row.num == 16) {
                                                        <span class="right-arrow"><i class="fa fa-caret-right"></i></span>
                                                      }
                                                      @if (row.num == '7b1' || row.num == '7b2' || row.num == 9 || row.num == 11 || row.num == '13a' || row.num == '13b' || row.num == 16) {
                                                        <span class="dollar-percent"><i class="fa fa-dollar"></i></span>
                                                      }
                                                      @if (row.num == '13c') {
                                                        <span class="dollar-percent"><i class="fa fa-percent"></i></span>
                                                      }
                                                      <!--End of Carrot & Dollar Symbol Code-->
                                                      @if (row.num == 10) {
                                                        <input type="checkbox"

                                                          [checked]="row.value === true"
                                                          name="{{row.num}}"
                                                          disabled="true">
                                                        }
                                                        @if (row.num == 16) {
                                                          <input type="text"
                                                            name="{{row.num}}"
                                                            [(ngModel)]="row.value_user_input"

                                                            class="form-control input-md"
                                                            disabled="true">
                                                          }
                                                          @if (row.num == '7b1' || row.num == '7b2' || row.num == 9 || row.num == 11 || row.num == '13a' || row.num == '13b' || row.num == '13c') {
                                                            <div [attr.data-ng-class]="{'color-red': row.value < 0 }"
                                                              class="input_disabled"
                                                            >{{row.value}}</div>
                                                          }
                                                        </td>
                                                        <td>
                                                          @if (row.num == 8 || row.num == 12 || row.num == 13 || row.num == '14a' || row.num == '14b' || row.num == 15 || row.num == 16 || row.num == 17 || row.num == 18) {
                                                            <div class="yes-no-div">
                                                              @if (row.value == true) {
                                                                <div>
                                                                  <span>
                                                                    <input type="checkbox" [checked]="true" name="{{row.num}}" class="radio" disabled="true">
                                                                  </span>
                                                                  <span>
                                                                    <input type="checkbox" name="{{row.num}}" class="radio" disabled="true">
                                                                  </span>
                                                                </div>
                                                              }
                                                              @if (row.value == false) {
                                                                <div>
                                                                  <span>
                                                                    <input type="checkbox" name="{{row.num}}" disabled="true">
                                                                  </span>
                                                                  <span>
                                                                    <input type="checkbox" [checked]="true" name="{{row.num}}" disabled="true">
                                                                  </span>
                                                                </div>
                                                              }
                                                            </div>
                                                          }
                                                        </td>
                                                      </tr>
                                                    }
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          }
                                        </div>
                                      }

                                      <!-- Audit Tab -->
                                      @if (activeTab === 3) {
                                        <div class="tab-pane active" style="overflow-y: auto; overflow-x: hidden; max-height: calc(90vh - 200px);">
                                          <div class="form-horizontal">
                                            @if (showRequestLoader) {
                                              <div class="row formLoader">
                                                <i class="fa fa-spinner fa-spin gt-refresh"></i>
                                              </div>
                                            }

                                            @if (!showRequestLoader) {
                                              <div class="row main-header">
                                                <div class="col-sm-4">
                                                  <span style="text-align: center; display: block;">Transaction Number</span>
                                                </div>
                                                <div class="col-sm-3">
                                                  <span>User</span>
                                                </div>
                                                <div class="col-sm-2">
                                                  <span>Date</span>
                                                </div>
                                                <div class="col-sm-3" style="padding-left: 20px">
                                                  <span>View Transactions</span>
                                                </div>
                                              </div>
                                            }

                                            @if (batchLoader) {
                                              <div class="viewBatchLoader">
                                                <i class="fa fa-spinner fa-spin gt-refresh"></i>
                                              </div>
                                            }

                                            @for (batchItem of BatchList; track $index; let batchIndex = $index) {
                                              <div class="row" style="margin: 8px 0px;">
                                                <div class="col-sm-4">
                                                  <span style="text-align: center; display: block;">{{batchItem.TRANSACTION_ID}}</span>
                                                </div>
                                                <div class="col-sm-3">
                                                  <span>{{batchItem.USER_FIRST_NAME}} {{batchItem.USER_LAST_NAME}}</span>
                                                </div>
                                                <div class="col-sm-2">
                                                  <span>{{batchItem.CREATED_ON}}</span>
                                                </div>
                                                <div class="col-sm-3">
                                                  <button type="button"
                                                    class="btn btn-primary view-trans-btn"
                                                    (click)="showUploads(batchIndex, batchItem.TRANSACTION_ID)"
                                                  [disabled]="batchItem.show_transaction">View Transactions</button>
                                                  <span>@if (batchItem.show_transaction) {
                                                    <i class="fa fa-spinner fa-spin gt-refresh"></i>
                                                  }</span>
                                                </div>
                                                @if (batchItem.TOGGLE) {
                                                  <div style="background: lightgray;width: 69%;margin-top: 28px;margin-left: 15%;">
                                                    @if (batchLoader) {
                                                      <div class="viewBatchLoader">
                                                        <i class="fa fa-spinner fa-spin gt-refresh"></i>
                                                      </div>
                                                    }

                                                    @if (showBatchData) {
                                                      <table class="table table-bordered form-inline">
                                                        <thead>
                                                          <tr style="background: #cd5763;color: white;font-weight: bold;">
                                                            <td style="width: 58px;padding: 0 20px;">#</td>
                                                            <td style="padding: 0 20px;">Description</td>
                                                            <td style="width: 110px;padding: 0;text-align: center;">Column A</td>
                                                            <td style="width: 110px;padding: 0;text-align: center;">Column B</td>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          @for (batchData of BatchListData; track $index) {
                                                            <tr>
                                                              <td style="width: 58px;padding: 0 20px;">{{batchData.LINE_NO}}</td>
                                                              <td style="padding: 0 20px;">{{batchData.LINE_DESCRIPTION}}</td>
                                                              <td style="width: 110px;padding: 0;" align="right">
                                                                <div style="background: white;border-radius: 4px;margin: 2px;text-align: center;">{{batchData.ATTRIBUTE_VALUE}}</div>
                                                              </td>
                                                              <td style="width: 110px;padding: 0;" align="right">
                                                                <div style="background: white;border-radius: 4px;margin: 2px;text-align: center;">{{batchData.ATTRIBUTE_VALUE_B}}</div>
                                                              </td>
                                                            </tr>
                                                          }
                                                        </tbody>
                                                      </table>
                                                    }
                                                  </div>
                                                }
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      }

                                      <!-- GOLD Tab -->
                                      @if (activeTab === 4) {
                                        <div class="tab-pane active" style="overflow-y: auto; overflow-x: hidden; max-height: calc(90vh - 200px);">
                                          <div class="Gold_Data_Block">
                                            <div>
                                              <div class="EO_block">
                                                <span>Effective Ownership Percentage By Owner</span>
                                                <span>- For tax year : {{rowData.TAX_YEAR}}</span>
                                              </div>
                                              <div>
                                                <table class="table table-bordered form-inline custom-table">
                                                  <thead>
                                                    <tr>
                                                      <td>Owner Id</td>
                                                      <td>Owner Name</td>
                                                      <td>Start Date</td>
                                                      <td>End Date</td>
                                                      <td>Eff. Own %</td>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    @for (prop of GoldData; track $index) {
                                                      <tr>
                                                        <td>{{prop.DO_OWNER_ID}}</td>
                                                        <td>{{prop.DO_OWNER_NAME}}</td>
                                                        <td>{{prop.DO_START_DATE}}</td>
                                                        <td></td>
                                                        <td>{{prop.DO_PER_OWNED}}</td>
                                                      </tr>
                                                    }
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>

                                            <div>
                                              <div class="DO_block">
                                                <span>Direct Ownership</span>
                                                <span>- Effective as of : {{rowData.TAX_YEAR}}</span>
                                              </div>
                                              <div>
                                                <table class="table table-bordered form-inline custom-table">
                                                  <thead>
                                                    <tr>
                                                      <td>Owner Id</td>
                                                      <td>Owner Name</td>
                                                      <td>Start Date</td>
                                                      <td>End Date</td>
                                                      <td>Total Holding</td>
                                                      <td>% Owned</td>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    @for (prop of GoldData; track $index) {
                                                      <tr>
                                                        <td>{{prop.DO_OWNER_ID}}</td>
                                                        <td>{{prop.DO_OWNER_NAME}}</td>
                                                        <td>{{prop.DO_START_DATE}}</td>
                                                        <td></td>
                                                        <td>{{prop.DO_TOTAL_HOLDING}}</td>
                                                        <td>{{prop.DO_PER_OWNED}}</td>
                                                      </tr>
                                                    }
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>

                                            <div>
                                              <div class="SUB_block">
                                                <span>Subsidiaries </span>
                                                <span>- For tax year : {{rowData.TAX_YEAR}}</span>
                                              </div>
                                              <div>
                                                <table class="table table-bordered form-inline custom-table">
                                                  <thead>
                                                    <tr>
                                                      <td>LEId</td>
                                                      <td>Legal Entity Name</td>
                                                      <td>Start Date</td>
                                                      <td>End Date</td>
                                                      <td>Eff. Own %</td>
                                                      <td>Tie Break</td>
                                                      <td>Calculation Method</td>
                                                      <td>Calculation Reason</td>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    @for (prop of GoldData; track $index) {
                                                      <tr>
                                                        <td>{{prop.SUB_LEID}}</td>
                                                        <td>{{prop.SUB_LE_NAME}}</td>
                                                        <td>{{prop.SUB_START_DATE}}</td>
                                                        <td>{{prop.SUB_END_DATE}}</td>
                                                        <td>{{prop.SUB_EFFECTIVE_OWNED_PER}}</td>
                                                        <td></td>
                                                        <td>{{prop.SUB_CALL_METHOD}}</td>
                                                        <td>{{prop.SUB_CALL_REASON}}</td>
                                                      </tr>
                                                    }
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  </div>

                                  <!-- STANDARD Footer -->
                                  <div class="modal-footer" [hidden]="minimise">
                                    @if (currentTabName != 'Subsidiary') {
                                      <button
                                        class="save-button"
                                        type="button"
                                        [disabled]="isSaveClicked"
                                        (click)="save()">
                                        @if (crudLoading) {
                                          <span><i class="fa fa-spinner fa-pulse"></i></span>
                                          }Save and Proceed
                                        </button>
                                      }
                                      @if (currentTabName != 'Subsidiary') {
                                        <button
                                          class="reset-button"
                                          type="button"
                                        (click)="reset()">Reset</button>
                                      }
                                      <button class="cancel-button"
                                        type="button"
                                      (click)="cancel()">Cancel</button>
                                    </div>

